import React from "react";

// Admin Imports
import MainDashboard from "./views/admin/default/index.jsx";
import Profile from "./views/admin/profile/index.jsx";
import DataTables from "./views/admin/tables/index.jsx";
import RTLDefault from "./views/rtl/default/index.jsx";
import ViewMember from "./components/Member/ViewMember.jsx";
import ViewCooperative from "./components/Cooperative/ViewCooperative.jsx";
// Auth Imports
import SignIn from "./views/auth/SignIn.jsx";

// View pages

import ViewActivity from "./components/Activity/ViewActivity.jsx";
import ViewIncome from "./components/Income/ViewIncome.jsx";
import ViewNew from "./components/News/ViewNew.jsx";
import ViewNews from "./components/News/ViewNews.jsx";
import ViewBanner from "./components/Banner/ViewBanner.jsx";
import ViewPayment from "./components/Payment/ViewPayment.jsx";
import ViewLoan from "./components/Loan/ViewLoan.jsx";

// Icon Imports
import {
  MdHome,
  MdPeople,
  MdBarChart,
  MdAttachMoney,
  MdOutlineVideoLibrary,
  MdPhoto,
  MdLock,
} from "react-icons/md";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },

    {
    name: "Cooperative Societies",
    layout: "/admin",
    path: "cooperatives",
    icon: <MdPeople className="h-6 w-6" />,
    component: <ViewCooperative />,
  },
  {
    name: "Members",
    layout: "/admin",
    path: "members",
    icon: <MdPeople className="h-6 w-6" />,
    component: <ViewMember />,
  },

    {
    name: "Loans",
    layout: "/admin",
    path: "loans",
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <ViewLoan />,
  },
 
  {
    name: "Activity",
    layout: "/admin",
    path: "activity",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <ViewActivity />,
  },
  {
    name: "Income",
    layout: "/admin",
    path: "income",
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <ViewIncome />,
  },
  {
    name: "Payments",
    layout: "/admin",
    path: "payments",
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <ViewPayment />,
  },
  {
    name: "News",
    layout: "/admin",
    path: "viewnews",
    icon: <MdOutlineVideoLibrary className="h-6 w-6" />,
    component: <ViewNews />,
  },
  {
    name: "Banner",
    layout: "/admin",
    path: "banner",
    icon: <MdPhoto className="h-6 w-6" />,
    component: <ViewBanner />,
  },

 

  {
    name: "users",
    layout: "/rtl",
    path: "rtl",
    icon: <MdHome className="h-6 w-6" />,
    component: <RTLDefault />,
  },
];
export default routes;
